import { RequestError } from '@adv-frontend/error';
import { Response } from '../../types';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment -- автоматический игнор в рамках DIRECT-265451. Исправьте при следующем редактировании при помощи type-assert, чтобы избежать возможных ложно-положительных проверок typecheck!
// @ts-expect-error DIRECT-235591 TS7030
export function getResponseFromError<Result>(error: unknown): Response<Result> | undefined {
    if (error instanceof RequestError) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- DIRECT-239681
        const data = (error.responseData as Result) ?? undefined;
        if (error.response) {
            return {
                data,
                headers: error.response.headers,
                status: error.response.status,
            };
        }
    }
}
